<template>
  <div class="todo-card" :class="{'flex': isTodo}"  @click="toPath(item.to)">
    <div class="img center " :style="{marginBottom: isFun?'10px':0,}">
      <img :src="imgurl" :class="[isFun?'img2':'img1']"/>
    </div>
    <div class="content">
      <div class="num center" v-if="showNumber">{{ item.num }}</div>
      <div class="title center">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default{
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    showNumber: {
      type: Boolean,
      default: true
    },
    mt: {
      type: Boolean,
      default: true
    },
    isTodo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imgurl () {
      if (this.isFun) {
        return require(`@/assets/img/${this.item.imgName}`)
      }
      const obj = {
        0: require('@/assets/img/sp.png'),
        1: require('@/assets/img/hs2.png'),
        2: require('@/assets/img/hy2.png'),
        3: require('@/assets/img/sp2.png'),
        4: require('@/assets/img/sq.png')
      }
      return obj[this.index]
    },
    isFun () {
      return !this.showNumber
    }
  },
  data () {
    return {
      num: 0
    }
  },
  methods: {
    toPath (url) {
      if (this.isFun) this.$router.push(url)
      if (this.isTodo) {
        switch (+this.index) {
          case 0:
            this.$router.push('/management-system/recyclingForm')
            break
          case 1:
            this.$router.push('/management-system/recyclingForm?index=third')
            break
          case 2:
            this.$router.push('/management-system/charityMember')
            break
          case 3:
            this.$router.push('/management-system/contentApproval')
            break
          case 4:
            this.$router.push('/management-system/appealList')
            break
          default:
            break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.todo-card{
  width: 100%;
  height:100%;
  // border: 1px solid red;
  background: #fff;
  cursor: pointer;
  .img{
    height: 40%;
      .img2{
        width: 20px;
        height:20px;
      }
    // @media screen and (max-width: 1680px) {
    //   .img1{ 
    //     width: 38px;
    //     height: 38px;
    //   }
    //   .img2{
    //     width: 15px;
    //     height:18px;
    //   }
    // }
    // @media screen and (min-width: 1680px) {
    //   .img1{ 
    //     width: 48px;
    //     height: 48px;
    //   }
    //   .img2{
    //     width: 20px;
    //     height:23px;
    //   }
    // }

    
  }
  .num{
    font-family: MiSans;
    font-weight: 500;
    font-size: 26px;
    color: #464C5E;
    height: 35%;
  }
  .title{
    font-family: MiSans;
    font-weight: 400;
    font-size: 16px;
    color: #464C5E;
    height: 25%;
  }
  .center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 1750px){
    padding-right: 0px;
    padding-left: 0px;
    .img{
      padding:10px;
    }
    .img1{ 
        width: 50px;
        height: 50px;
      }
    .num{
      font-size: 22px;
      padding-right: 40px;
    }
    .title{
      font-size: 16px;
    }
  }
  @media screen and (min-width:1750px) and (max-width: 2100px){
    padding-right: 10px;
    padding-left: 10px;
    .img{
      padding:15px;
    }
    .img1{ 
        width: 53px;
        height: 53px;
      }
    .num{
      font-size: 23px;
      padding-right: 40px;
    }
    .title{
      font-size: 16px;
    }
  }
  @media screen and (min-width: 2100px) and (max-width: 2250px) {
    padding-right: 30px;
    padding-left: 30px;
    .img{
      padding:20px;
    }
    .img1{ 
        width: 55px;
        height: 55px;
      }
    .num{
      font-size: 23px;
      padding-right: 40px;
    }
    .title{
      font-size: 17px;
    }
  }
  @media screen and (min-width: 2250px){
    padding-right: 50px;
    padding-left: 50px;
  }
  .content{
    flex:1;
    height: 100%;
    display: flex;
    flex-direction: column; 
    justify-content: space-around;
    
  }
}
</style>